export const CLIENTS_GET = "clientsGet";
export const CLIENT_GET = "clientGet";
export const CLIENT_SEARCH = "clientSearch";
export const CLIENT_CREATE = "clientCreate";
export const CLIENT_UPDATE = "clientUpdate";
export const CLIENT_ACTIVE = "clientActive";
export const CLIENT_INACTIVE = "clientInactive";
export const CLIENT_DELETE = "clientDelete";